// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://obuhrpfphcqeqpvttcum.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9idWhycGZwaGNxZXFwdnR0Y3VtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0MTQwMTEsImV4cCI6MjA1Njk5MDAxMX0.rbn-xZcGZcjzYD7OFgATMJO74CXYkxFQDdmIRNQf808";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});